import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CheckSignedDocumentComponent } from './check-signed-document/check-signed-document.component';


export const publicRoutes: Routes = [
  { path: 'CheckSignedDocument/:documentToSignID', component: CheckSignedDocumentComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(publicRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class PublicRoutingModule {}

